
export default {
    components: {
        SmileyIcon: () => import('~/components/ui/icon/SmileyIcon'),
        PlanSwitcherPointer: () => import('~/components/ui/icon/PlanSwitcherPointer')
    },
    props: ['selectedType'],
    emits: ['switch']
}
